/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Not Linked Icon component.
 */
export const SystemNotLinkedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9.91668 10.3237C10.4872 10.1777 10.9925 9.84516 11.3523 9.37894C11.7121 8.91273 11.9056 8.3396 11.9022 7.75071C11.8988 7.16183 11.6985 6.59102 11.3333 6.12904C10.9681 5.66707 10.4589 5.34045 9.88672 5.20117' stroke={iconColor} strokeMiterlimit='10' />
      <path d='M10.7266 3.5918C11.6566 3.82047 12.4838 4.35293 13.077 5.10482C13.6702 5.8567 13.9956 6.78504 14.0016 7.74276C14.0077 8.70048 13.6939 9.63283 13.1102 10.3921C12.6097 11.0432 11.9351 11.5351 11.1685 11.8136' stroke={iconColor} strokeMiterlimit='10' />
      <path d='M6.74902 4.91406H8.05664C8.33267 4.9142 8.55664 5.138 8.55664 5.41406V7.37695L12.8926 13.2881L12.0869 13.8789L3.80469 2.5918L4.61133 2L6.74902 4.91406ZM8.36133 10.4912C8.27675 10.5569 8.172 10.5986 8.05664 10.5986H1.5C1.22408 10.5986 1.00036 10.3745 1 10.0986V5.41406C1 5.13792 1.22386 4.91406 1.5 4.91406H4.26953L8.36133 10.4912Z' fill={iconColor} />
    </svg>
  );
};

export default SystemNotLinkedIcon;
